'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Alibar = (_temp = _class = function (_React$Component) {
    _inherits(Alibar, _React$Component);

    function Alibar() {
        _classCallCheck(this, Alibar);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Alibar.prototype.componentDidMount = function componentDidMount() {
        if (document) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//astyle-src.alicdn.com/sys/js/universal/alibar/v6/v6.js';
            document.body.appendChild(script);
        }
    };

    Alibar.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            prefix = _props.prefix,
            className = _props.className,
            width = _props.width,
            color = _props.color,
            others = _objectWithoutProperties(_props, ['prefix', 'className', 'width', 'color']);

        var cls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'alibar', true), _defineProperty(_classNames, className, className), _classNames));

        var w = width ? width : '1200';
        var style = color === 'black' ? { height: '29px', backgroundColor: '#363636', borderBottom: '1px solid #363636' } : { height: '29px', backgroundColor: '#fff', borderBottom: '1px solid #ddd' };

        return _react2['default'].createElement(
            'div',
            { className: cls },
            _react2['default'].createElement('div', _extends({}, others, { id: 'alibar', 'data-width': w, 'data-bgcolor': color, style: style }))
        );
    };

    return Alibar;
}(_react2['default'].Component), _class.propTypes = {
    prefix: _react2['default'].PropTypes.string,
    className: _react2['default'].PropTypes.string,
    width: _react2['default'].PropTypes.string,
    color: _react2['default'].PropTypes.string
}, _class.defaultProps = {
    prefix: 'alife-bc-'
}, _temp);
Alibar.displayName = 'Alibar';
exports['default'] = Alibar;
module.exports = exports['default'];